import React, { PropsWithChildren } from "react";
import Badge from "ui/Badge/Badge";
import Tooltip from "ui/Tooltip/Tooltip";
import { BadgeProps } from "ui/Badge/Badge";
import { TooltipProps } from "ui/Tooltip/Tooltip";
import { parseFromFormat } from "helpers/date";

type Props = {
  badge: Entity.ProductBadge;
  badgeProps?: BadgeProps;
  tooltipProps?: Pick<TooltipProps, "placement" | "width" | "maxWidth">;
  alt?: string;
};

const BadgeWithTooltip: React.FC<PropsWithChildren<Props>> = ({
  badge,
  badgeProps,
  tooltipProps,
  children,
  alt,
}: PropsWithChildren<Props>) => {
  return (
    <Tooltip
      maxWidth={tooltipProps?.maxWidth}
      width={tooltipProps?.width}
      placement={tooltipProps?.placement}
      title={
        (badge.description || badge.dateEnd) && (
          <div>
            {badge.description && <div>{badge.description}</div>}
            {badge.dateEnd && (
              <div style={{ whiteSpace: "nowrap" }}>
                {badge.type === "action" ? "Акция" : "Скидка"} действует до:{" "}
                {parseFromFormat(badge.dateEnd, "YYYY-MM-DD").format(
                  "DD.MM.YYYY"
                )}
              </div>
            )}
          </div>
        )
      }
    >
      <Badge type={badge.type} {...badgeProps}>
        {children ? (
          children
        ) : badge.src ? (
          <img src={badge.src} alt={alt} />
        ) : (
          badge.title
        )}
      </Badge>
    </Tooltip>
  );
};

export default BadgeWithTooltip;
